export default __webpack_public_path__ + "static/media/babs.2ef84c40.jpg";